import $ from 'jquery'
import gsap from 'gsap';
import {initRRoll, destroyRRoll} from './../shared/r-roll.js'

import Controller from "./Controller.js";

class RRollController extends Controller {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    this.initRoll();
  }
  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    super.addEventListeners();
    window.addEventListener('resize', this.onWindowResize);
    document.addEventListener('rroll.slide', this.onDocumentRRollSlide);
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    super.removeEventListeners();
    window.removeEventListener('resize', this.onWindowResize);
    document.removeEventListener('rroll.slide', this.onDocumentRRollSlide);
    this.destroyRoll();
  }
  /**
   * ### OWN ###
   */
  initRoll() {
    const container = document.querySelector(this.getContainerSelector());
    if (container) {
      // set descr wrapper height based on all the slide contents
      this.setDescrWrapperHeight();
      // set first descr
      const firstEl = container.querySelector('.item-list-slide');
      this.updateSlideDescr(firstEl);
      initRRoll(container);
    }
  }
  destroyRoll() {
    const container = document.querySelector(this.getContainerSelector());
    if (container) {
      destroyRRoll(container);
    }
  }
  // # Event Handlers
  onDocumentRRollSlide = (e) => {
    this.updateSlideDescr(e.detail?.nextItem);
  }
  onWindowResize = (e) => {

  }
  // update slide descr (next EL can be slide item or inner <a> element)
  updateSlideDescr = (nextEl) => {
    const container = document.querySelector(this.getContainerSelector());
    const descrWrapper = container ? container.parentNode.querySelector('.descr-wrapper') : null;
    // console.log("NEXT element: ", nextEl, descrWrapper);
    if (!descrWrapper || !nextEl) {
      return false;
    }
    // hide current description
    const currentDescr = descrWrapper.querySelector('.descr-inner');
    if (currentDescr) {
      gsap.killTweensOf(currentDescr);
      gsap.to(currentDescr, {x: '-100%', duration: .4, ease: 'power2.in', onComplete: () => {
        currentDescr.remove();
      }});
    }
    // show new description
    const nextDescr = nextEl.querySelector('.slide-decr-wrapper');
    if (nextDescr) {
      let div = document.createElement('div');
      div.innerHTML = nextDescr.innerHTML;
      div.classList.add("descr-inner");
      descrWrapper.appendChild(div);
      gsap.set(div, {x: '100%'});
      gsap.to(div, {x: '0%', duration: .4, delay: .24, ease: 'power2.Out'});
    }
  }
  // update height
  setDescrWrapperHeight = () => {
    const container = document.querySelector(this.getContainerSelector());
    if (!container) {
      return false;
    }
    const descrWrapper = container.parentNode.querySelector('.descr-wrapper');
    if (!descrWrapper) {
      return false;
    }
    const oryginHtml = descrWrapper.innerHTML;
    const list = container.querySelectorAll('.item-list-slide');
    let height = 0;
    list.forEach((el) => {
      const descr = el.querySelector('.slide-decr-wrapper');
      if (descr) {
        descrWrapper.innerHTML = descr.innerHTML;
        height = Math.max(height, descrWrapper.clientHeight);
      }  
    });
    descrWrapper.innerHTML = oryginHtml;
    descrWrapper.style.minHeight = height + 'px';
  }


}
export default RRollController